import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AlertTypesEnum } from "../interfaces/AlertTypesEnum";

@Injectable({
    providedIn: 'root',
})
export class AlertMessageService {
    alertMessage$ = new BehaviorSubject<{content: string, type: string, autoHide?: number, closeButtonName?: string, width?: string}>(null);

    displayAlert(content: string, type: AlertTypesEnum, autoHide: number = 3, width: string = 'fit-content', closeButtonName?: string): void {
        this.alertMessage$.next({content, type, autoHide, width, closeButtonName});
    }
}